export { Text, getTextFromI18n } from './TextLocalized';
